<template>
  <div>
    <div class="flashEclosure">
      <flash-message :add-bottom-margin="flashBottomMargin" size="is-size-7"></flash-message>
    </div>
    <div class="columns profile-columns">
      <!-- LEFT PANEL -->
      <div class="column is-one-third-tablet">
        <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
        <article v-if="hasUserProfile" class="media is-hidden-tablet is-mobile">
          <figure class="media-left">
            <avatar :background-color="avatarBackground" :size="avatarSizeMobile" :username="userDetails.displayName"
                    color="#ffffff" v-if="!hasProfileImage"></avatar>
            <avatar :background-color="avatarBackground" :size="avatarSizeMobile" :src="getProfileImage"
                    :username="userDetails.displayName" color="#ffffff" v-if="hasProfileImage"></avatar>
            <!--<avatar-cropper
                    trigger="#pick_logo_mobile"
                    :upload-url="upload_url"
                    @uploading="handleUploading"
                    @completed="handleCompleted"
                    :upload-headers="upload_headers"
                    :labels="labels"
                    mimes="image/png,image/gif,image/jpeg">
            </avatar-cropper>
            <div class="has-text-centered">
              <button class="button-edit is-button-grey circle-border pick-logo-image"
                      :class="{'is-loading': is_uploading_profile_image }"
                      v-show="isLoggedIn && isProfileOwner"
                      id="pick_logo_mobile">
                <i class="fas fa-pencil-alt"></i>
              </button>
            </div>-->
          </figure>
          <div class="media-content">
            <h4 v-html="printUserName"></h4>
            <p class="active-since has-text-left" v-html="activeSince"></p>
            <div class="reviewer-badge">
              <div class="level is-mobile">
                <div class="level-item">
                  <p class="has-text-weight-bold" v-html="getReviewerScore"></p>
                </div>
                <div class="level-left level-item">
                  <p class="has-text-weight-bold"><i v-html="getReviewerScoreText"></i></p>
                </div>
              </div>
            </div>
          </div>
        </article>
        <div class="user-image is-hidden-mobile is-hidden-tablet-only" v-if="hasUserProfile">
          <avatar :background-color="avatarBackground" :size="avatarSizeDesktop" :username="userDetails.displayName"
                  color="#ffffff"
                  v-if="!hasProfileImage"></avatar>
          <avatar :background-color="avatarBackground" :size="avatarSizeDesktop" :src="getProfileImage"
                  :username="userDetails.displayName" color="#ffffff" v-if="hasProfileImage"></avatar>
          <!--<avatar-cropper
                  trigger="#pick_logo"
                  :upload-url="upload_url"
                  @uploading="handleUploading"
                  @completed="handleCompleted"
                  :upload-headers="upload_headers"
                  :labels="labels"
                  mimes="image/png,image/gif,image/jpeg">
          </avatar-cropper>
          <div class="has-text-centered">
            <button class="button-edit is-button-grey circle-border pick-logo-image"
                    :class="{'is-loading': is_uploading_profile_image }"
                    v-show="isLoggedIn && isProfileOwner"
                    id="pick_logo">
              <i class="fas fa-pencil-alt"></i>
            </button>
          </div>-->
        </div>
        <div class="user-image is-hidden-mobile is-hidden-desktop" v-if="hasUserProfile">
          <avatar :background-color="avatarBackground" :size="avatarSizeTablet" :username="userDetails.displayName"
                  color="#ffffff"
                  v-if="!hasProfileImage"></avatar>
          <avatar :background-color="avatarBackground" :size="avatarSizeTablet" :src="getProfileImage"
                  :username="userDetails.displayName" color="#ffffff" v-if="hasProfileImage"></avatar>
          <!--<avatar-cropper
                  trigger="#pick_logo_tablet"
                  :upload-url="upload_url"
                  @uploading="handleUploading"
                  @completed="handleCompleted"
                  :upload-headers="upload_headers"
                  :labels="labels"
                  mimes="image/png,image/gif,image/jpeg">
          </avatar-cropper>
          <div class="has-text-centered">
            <button class="button-edit is-button-grey circle-border pick-logo-image"
                    :class="{'is-loading': is_uploading_profile_image }"
                    v-show="isLoggedIn && isProfileOwner"
                    id="pick_logo_tablet">
              <i class="fas fa-pencil-alt"></i>
            </button>
          </div>-->
        </div>
        <h4 class="is-hidden-mobile user-name has-text-centered has-text-weight-bold" v-html="printUserName"></h4>
        <p class="is-hidden-mobile active-since has-text-centered" v-html="activeSince"></p>
        <div class="is-hidden-mobile reviewer-badge">
          <div class="level">
            <div class="level-item">
              <p class="has-text-weight-bold" v-html="getReviewerScore"></p>
            </div>
            <div class="level-item">
              <p class="has-text-weight-bold"><i v-html="getReviewerScoreText"></i></p>
            </div>
          </div>
        </div>
        <p class="is-hidden-mobile bio has-text-centered" v-html="getBio" v-if="hasBio"></p>
        <div class="is-hidden-mobile columns totals-columns">
          <div class="column totals-card">
            <p class="has-text-centered has-text-weight-bold" v-html="getTotalReviews"></p>
            <p class="has-text-centered">REVIEWS</p>
          </div>
          <div class="column totals-card">
            <p class="has-text-centered has-text-weight-bold" v-html="getTotalIndustries"></p>
            <p class="has-text-centered">INDUSTRIES</p>
          </div>
        </div>
        <div class="is-hidden-mobile ratings">
          <star-rating-widget
            :box-shadow="boxShadow"
            :final-score="averageRating"
            :five="fiveStar"
            :four="fourStar"
            :hide-logo="starDescriptionText"
            :hide-summary="starDescriptionText"
            :no-left-right-pad="noLeftRightPad"
            :one="oneStar"
            :profile-view="profileView"
            :short-summary="!starDescriptionText"
            :smaller-font-size="starDescriptionText"
            :star-description-text="starDescriptionText"
            :three="threeStar"
            :top-margin-small="smallTopMargin"
            :total-reviews="totalReviews"
            :transparent-background="transparentBackground"
            :two="twoStar"></star-rating-widget>
        </div>
        <div class="is-hidden-mobile edit-options" v-if="isLoggedIn && isProfileOwner">
          <a @click.prevent="editProfile" class="edit-button has-icons-left">
          <span class="icon is-medium is-left">
            <i class="fas fa-cog"></i>
          </span>
            <span class="is-size-6">Edit profile</span>
          </a>
          <a @click.prevent="editPassword" class="edit-button has-icons-left">
          <span class="icon is-medium">
            <i class="fas fa-key"></i>
          </span>
            <span class="is-size-6">Change password</span>
          </a>
        </div>


        <!-- MOBILE TABS -->
        <div class="columns is-hidden-tablet is-fullwidth tabs-columns">
          <div class="column is-paddingless">
            <div class="tabs">
              <ul>
                <li :class="{ 'is-active': showReviewsTab }"><a @click.prevent="changeMobileTabs">Reviews</a></li>
                <li :class="{ 'is-active': showDetailsTab }"><a @click.prevent="changeMobileTabs">Profile</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- RIGHT PANEL -->
      <div class="column" v-if="showReviewsTab">
        <div class="is-hidden-mobile">
<!--          <leader-board-fluid :bottom-margin="leaderBoardBottomMargin"></leader-board-fluid>-->
          <p v-if="!isMobileAds" class="has-text-centered">
            <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd" :no-top-margin="hideFirstDesktopAd"></ad>
          </p>
        </div>
        <p class="has-text-centered spinner" v-if="fetching_reviews"><img alt="Fetching all industries"
                                                                          src="/static/img/others/spinner.svg"/></p>
        <div class="columns is-multiline" v-if="!fetching_reviews">
          <div class="column is-full-tablet review-row" v-for="(reviewItem, index) in items">
            <user-profile-review-card
              :attachments="reviewItem.attachments"
              :author-id="reviewItem.author_id"
              :review="reviewItem"
              :reviewIndex="index"
              :show-business="showBusinessInReviewCards"
              :show-business-avatar="showBusinessInReviewCards"
              :show-rate-btn="canShowRateBtn(reviewItem.created_at)"
              :showNPSRating="!isLoggedIn || !isProfileOwner"
              :showNPSScore="isProfileOwner"
            >
            </user-profile-review-card>
          </div>
        </div>
        <paginator :dataSet="dataSet" @changed="getUserReviews"></paginator>
      </div>
      <!-- MOBILE DETAILS -->
      <div class="column is-hidden-tablet mobile-profile" v-if="showDetailsTab">
        <p class="bio has-text-left" v-html="getBio" v-if="hasBio"></p>
        <div class="columns totals-columns is-mobile">
          <div class="column totals-card">
            <p class="has-text-centered has-text-weight-bold" v-html="getTotalReviews"></p>
            <p class="has-text-centered">REVIEWS</p>
          </div>
          <div class="column totals-card">
            <p class="has-text-centered has-text-weight-bold" v-html="getTotalIndustries"></p>
            <p class="has-text-centered">INDUSTRIES</p>
          </div>
        </div>
        <div class="totals-columns">
          <star-rating-widget
            :box-shadow="boxShadow"
            :final-score="averageRating"
            :five="fiveStar"
            :four="fourStar"
            :hide-logo="starDescriptionText"
            :hide-summary="starDescriptionText"
            :mobile-profile-view="profileView"
            :no-left-right-pad="noLeftRightPad"
            :one="oneStar"
            :profile-view="profileView"
            :short-summary="!starDescriptionText"
            :smaller-font-size="starDescriptionText"
            :star-description-text="starDescriptionText"
            :three="threeStar"
            :top-margin-small="smallTopMargin"
            :total-reviews="totalReviews"
            :transparent-background="transparentBackground"
            :two="twoStar"></star-rating-widget>
        </div>
        <div class="edit-options" v-if="isLoggedIn && isProfileOwner">
          <a @click.prevent="editProfile" class="edit-button has-icons-left">
          <span class="icon is-medium is-left">
            <i class="fas fa-cog"></i>
          </span>
            <span class="is-size-6">Edit profile</span>
          </a>
          <a @click.prevent="editPassword" class="edit-button has-icons-left">
          <span class="icon is-medium">
            <i class="fas fa-key"></i>
          </span>
            <span class="is-size-6">Change password</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* global googletag */
  /* eslint no-undef: "error" */

  import axios from 'axios'
  import moment from 'moment'
  import AvatarCropper from 'vue-avatar-cropper'
  import auth from '@/mixins/auth'
  import StarRatingWidget from '@/components/StarRatingWidget'
  import collection from '../../mixins/collection.js'
  import Paginator from '@/components/Paginator'
  import ReviewCard from '@/components/ReviewCard'
  import UserProfileReviewCard from '@/components/UserProfileReviewCard'
  import LeaderBoardFluid from '@/components/LeaderBoardFluid'
  import Avatar from 'vue-avatar/src/Avatar'
  import FlashMessage from '@/components/FlashMessage'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'

  export default {
    name: 'UserProfile',
    props: {
      uuid: {
        type: String
      }
    },
    mixins: [auth, collection, adsConfig],
    components: {
      AvatarCropper,
      Avatar,
      Paginator,
      ReviewCard,
      LeaderBoardFluid,
      StarRatingWidget,
      FlashMessage,
      UserProfileReviewCard,
      Ad
    },
    metaInfo () {
      return {
        title: this.getMetaTitle,
        titleTemplate: '%s | hellopeter.com',
        bodyAttrs: {
          class: 'profile'
        },
        meta: this.getMeta,
        link: { rel: 'canonical', href: `${process.env.APP_URL}${this.$route.path}` }
      }
    },
    data () {
      return {
        fetching_reviews: false,
        apiCallCount: 0,
        avatarBackground: '#20BEAB',
        dataSet: false,
        showBusinessInReviewCards: true,
        keyword_search: '',
        filter_search: '',
        current_review_fetch_url: '',
        leaderBoardBottomMargin: true,
        showReviewsTab: true,
        showDetailsTab: false,
        userDetails: null,
        avatarSizeDesktop: 180,
        avatarSizeTablet: 150,
        avatarSizeMobile: 80,
        smallTopMargin: true,
        starDescriptionText: true,
        averageRating: 0,
        totalReviews: 0,
        oneStar: 0,
        twoStar: 0,
        threeStar: 0,
        fourStar: 0,
        fiveStar: 0,
        noLeftRightPad: true,
        transparentBackground: true,
        boxShadow: false,
        profileView: true,
        flashBottomMargin: true,
        upload_url: `${process.env.API_URL}/consumer/user/${this.uuid}/upload-profile-image`,
        upload_headers: {
          'Authorization': 'Bearer ' + localStorage.auth_token
        },
        labels: {
          submit: 'Crop',
          cancel: 'Cancel'
        },
        form_data: {
          user_uuid: this.uuid
        },
        is_uploading_profile_image: false
      }
    },
    created () {
      window.events.$on('updatePasswordComplete', (data) => {
        flash(data.body, data.header)
        window.scrollTo(0, 0)
      })
      window.events.$on('updateProfileComplete', (data) => {
        this.userDetails.bio = data.bio
        flash(data.body, data.header)
        window.scrollTo(0, 0)
      })
      window.events.$on('handleDeleteReview', (data) => {
        this.handleDeleteReview(data)
      })
      window.events.$on('deleteReview', (data) => {
        this.handlePostDeleteReview(data)
      })
      this.getUserDetails()
      this.getUserReviewBreakdown()
        .then((breakdown) => {
          if (!this.isMobileAds) {
            const reviewerType = this.getReviewerScoreText
            let avgScore = 0
            if (breakdown['totalReviews'] > 0) {
              const accumulated = Object.entries(breakdown['data']).reduce((acc, current) => acc + parseInt(current[0]) * current[1], 0)
              avgScore = (accumulated / breakdown['totalReviews']).toFixed(1)
            }
            googletag.cmd.push(() => {
              googletag.pubads().setTargeting('Pagetype', this._routeName)
              googletag.pubads().setTargeting('URL', window.location.href)
              googletag.pubads().setTargeting('Reviewer Type', reviewerType)
              googletag.pubads().setTargeting('Average Score', avgScore)
              googletag.pubads().collapseEmptyDivs()
              googletag.enableServices()
            })
          }
        })
      let query = location.search.match(/page=(\d+)/)
      let page = query ? query[1] : 1
      this.getUserReviews(page)
      window.events.$on('rateBusinessComplete', (data) => {
        flash(data.body, data.header)
        this.getUserReviews(page, true)
        window.scrollTo(0, 0)
      })
    },
    mounted () {
      if (!this.isMobileAds) {
        if (this.isLoggedIn) {
          this.loadAds()
        } else {
          this.loadAds('MyProfile')
        }
      }
    },
    methods: {
      canShowRateBtn (reviewDatetime) {
        const fourDaysAgo = moment().subtract(4, 'days').format('YYYY-MM-DD');
        reviewDatetime = moment(reviewDatetime).format('YYYY-MM-DD');
        return this.isProfileOwner && moment(fourDaysAgo).isSameOrAfter(reviewDatetime) //User is visiting own profile and review is posted atleast 4 days ago
      },
      getUserReviews (page, callApiWithoutCondition = false) {
        const reviewFetchUrl = this.url(page, this.keyword_search, this.filter_search)
        if (reviewFetchUrl !== this.current_review_fetch_url || callApiWithoutCondition) {
          this.current_review_fetch_url = reviewFetchUrl
          this.fetching_reviews = true
          axios.get(reviewFetchUrl)
            .then((response) => {
              this.dataSet = response.data
              this.items = response.data.data
              this.fetching_reviews = false
            })
            .catch((error) => {
              this.fetching_reviews = false
              console.log('error', error)
            })
        }
      },
      url (page, keyword, filter) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }

        if (keyword.length > 0) {
          page += `&${keyword}`
        }

        if (filter.length > 0) {
          //
        }

        return `/consumer/user/${this.uuid}/reviews?page=${page}`
      },
      getUserDetails () {
        axios.get(`/consumer/user/${this.uuid}/details`)
          .then(({data}) => {
            this.userDetails = data
            this.totalReviews = data.total_reviews
            this.$gtm.trackEvent({
              event: 'pageLoad',
              virtualPageUrl: this.$router.currentRoute.path,
              virtualPageTitle: `${this.userDetails.displayName}'s Profile`,
              brandName: '',
              industryName: ''
            })
            if (typeof data.avatar !== 'undefined' && data.avatar !== null && data.avatar.length > 0) {
              this.userDetails.avatar = data.avatar  + '?' + Math.floor((Math.random() * 100) + 1)
            }
          })
          .catch(() => {
            window.location.href = '/404'
          })
      },
      getUserReviewBreakdown () {
        return new Promise((resolve, reject) => {
          axios.get(`consumer/user/${this.uuid}/review-breakdown`)
            .then(({data}) => {
              this.oneStar = data['1']
              this.twoStar = data['2']
              this.threeStar = data['3']
              this.fourStar = data['4']
              this.fiveStar = data['5']
              const reviewSum = data['1'] + data['2'] + data['3'] + data['4'] + data['5']
              if (reviewSum > 0 && this.totalReviews === 0) {
                this.totalReviews = reviewSum
              }
              resolve({totalReviews: reviewSum, data: data})
            })
            .catch((error) => {
              console.log('error', error)
              reject(error)
            })
        })
      },
      changeMobileTabs () {
        this.showReviewsTab = !this.showReviewsTab
        this.showDetailsTab = !this.showDetailsTab
      },
      editPassword () {
        const options = {
          'title': 'Change password?',
          'body': '',
          'btn_action_title': 'CHANGE PASSWORD',
          'show_btns': true,
          'show_cancel_btn': false,
          'show_close_btn': true,
          'task': '',
          'setWidthAuto': true,
          'isUpdatePassword': true,
          'profileUUID': this.uuid,
          'producer': {}
        }
        modal(options)
      },
      editProfile () {
        const options = {
          'title': 'Edit profile',
          'body': '',
          'btn_action_title': 'SAVE CHANGES',
          'show_btns': true,
          'show_cancel_btn': false,
          'show_close_btn': true,
          'task': '',
          'setWidthAuto': true,
          'isEditProfile': true,
          'profileUUID': this.uuid,
          'producer': {}
        }
        modal(options)
      },
      handleUploading () {
        this.is_uploading_profile_image = true
      },
      handleCompleted (response) {
        this.is_uploading_profile_image = false
        if (typeof response.success !== 'undefined' && response.success === true && typeof response.uploaded !== 'undefined') {
          this.userDetails.avatar = response.uploaded + '?' + Math.floor((Math.random() * 100) + 1)
        }
      },
      /**
       * Handling for dropdown in review card dropdown
       * @param {object} data
       * @return {void}
       */
      handleDeleteReview (data) {
        modal({
          title: 'Delete review',
          body: 'This action cannot be undone.',
          btn_action_title: 'DELETE',
          show_btns: true,
          show_cancel_btn: true,
          show_close_btn: false,
          reviewId: data.reviewId,
          reviewIndex: data.reviewIndex,
          businessSlug: data.reviewPermalink,
          deleteReview: true,
          task: 'deleteReview'
        })
      },
      /**
       * Handling the event after deleting the review
       * @param {object} data
       * @return {void}
       */
      handlePostDeleteReview (data) {
        this.items.splice(data.reviewIndex, 1)
        --this.userDetails.total_reviews
        let query = location.search.match(/page=(\d+)/)
        let page = query ? query[1] : 1
        this.getUserDetails()
        this.getUserReviews(page)
        this.getUserReviewBreakdown()
        window.scrollTo(0, 0);
      }
    },
    computed: {
      hasUserProfile () {
        return this.userDetails !== null
      },
      hasBio () {
        return this.userDetails !== null && this.userDetails.bio !== null
      },
      printUserName () {
        if (this.userDetails !== null) {
          return this.userDetails.displayName.replace(/\s/g, '&nbsp;')
        }
        return ''
      },
      activeSince () {
        if (this.userDetails !== null) {
          const theDate = moment(this.userDetails.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY')
          return `Active since: ${theDate}`
        }
        return ''
      },
      getTotalIndustries () {
        if (this.userDetails !== null) {
          return this.userDetails.total_industries
        }
        return `0`
      },
      getTotalReviews () {
        if (this.userDetails !== null) {
          return this.userDetails.total_reviews
        }
        return `0`
      },
      getReviewerScore () {
        if (this.userDetails !== null) {
          if (this.userDetails.total_reviews >= 11) {
            return `1`
          } else if (this.userDetails.total_reviews >= 4) {
            return `2`
          }
        }
        return `3`
      },
      getReviewerScoreText () {
        if (this.userDetails !== null) {
          if (this.userDetails.total_reviews >= 11) {
            return `All-Star&nbsp;reviewer`
          } else if (this.userDetails.total_reviews >= 4) {
            return `Amateur&nbsp;Reviewer`
          }
        }
        return `Rookie&nbsp;Reviewer`
      },
      getBio () {
        if (this.userDetails !== null && this.userDetails.bio !== null) {
          return `${this.userDetails.bio}`
        }
        return ``
      },
      getMetaTitle () {
        if (this.userDetails !== null) {
          return `${this.userDetails.displayName}'s Profile`
        }
        return ''
      },
      getMeta () {
        if (this.userDetails !== null) {
          return [
            { name: 'description', content: `Read all the reviews submitted by ${this.userDetails.displayName}` },
            { name: 'robots', content: 'noindex,nofollow' }
          ]
        }
        return []
      },
      isProfileOwner () {
        const loggedInProfile = localStorage.getItem('profile_id')
        if (typeof loggedInProfile !== 'undefined' && loggedInProfile !== null && typeof this.uuid !== 'undefined' && this.userDetails !== null) {
          return loggedInProfile === this.userDetails.uuid
        }
        return false
      },
      hasProfileImage () {
        return this.userDetails !== null && this.userDetails.avatar !== null
      },
      getProfileImage () {
        return this.userDetails.avatar
      }
    }
  }
</script>
<style scoped>

  .flashEclosure {
    max-width: 1125px;
    margin: 6rem auto 0 auto !important;
  }

  .profile-columns {
    max-width: 1125px;
    color: #58595B;
    margin: 1rem auto 2rem auto;
  }

  .profile-columns > .column:first-child {
    background-color: #F5F5F5;
  }

  .profile-columns > .column {
    padding-top: 0;
  }

  .profile-columns > .column:nth-child(2) {
    padding-left: 4rem;
    padding-right: 0;
  }

  .vue-avatar--wrapper {
    margin: 4rem auto 2rem auto;
  }

  .user-name {
    color: #58595B;
    font-size: 1.6rem;
  }

  .active-since {
    color: #8A8C91;
    font-size: 0.85rem;
  }

  .reviewer-badge {
    padding: 1rem;
    background-color: #ffffff;
    width: 100%;
    max-width: 240px;
    margin: 1.5rem auto;
  }

  .reviewer-badge > .level > .level-item > p {
    color: #30AAE1;
    line-height: 39px;
    height: 42px;
  }

  .reviewer-badge > .level > .level-item:first-child > p {
    width: 37px;
    background-image: url('/static/img/others/rank@3x.png');
    background-size: 100% 100%;
    padding-left: 9px;
  }

  .bio, .totals-columns {
    max-width: 278px;
    margin: 2rem auto;
  }

  .bio {
    font-size: 1rem;
  }

  .totals-card {
    box-shadow: 0px 0px 23px -1px rgba(166, 159, 166, 0.32);
    background-color: #ffffff;
  }

  .totals-columns > .column:first-child {
    margin-right: 10px;
  }

  .totals-columns > .column:nth-child(2) {
    margin-left: 10px;
  }

  .totals-card > p:first-child {
    font-size: 2.5rem;
    font-weight: 900 !important;
  }

  .totals-card > p:nth-child(2) {
    font-size: 0.8rem;
    margin-top: -7px;
  }

  .ratings {
    border: none;
    box-shadow: none;
    background-color: transparent;
    max-width: 278px;
    margin: 0 auto;
  }

  .edit-options {
    max-width: 278px;
    margin: 2rem auto;
  }

  .edit-button, .edit-button:hover, .edit-button:visited {
    display: block;
    width: 100%;
    height: 70px;
    line-height: 70px;
    font-size: 1.2rem;
    color: #58595B;
    text-decoration: none;
    border-top: 1px solid #C9C9C9;
  }

  .circle-border, .circle-border:hover {
    background-color: #565e65;
    width: 42px;
    height: 42px;
    border-radius: 50%;
  }


  .pick-logo-image {
    top: -70px;
    left: 60px;
  }

  .button-edit {
    font-size: 1rem;
    padding-top: calc(0.375em - 1px);
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    line-height: normal;
    position: relative;
    color: #31AAE1 !important;
  }

  #pick_logo_mobile {
    top: -25px;
    left: 35px;
  }

  @media screen and (max-width: 1024px) {
    .profile-columns {
      max-width: 95%;
    }

    .profile-columns > .column:nth-child(2) {
      padding-left: 2rem;
      padding-right: 0;
    }

    .profile-columns > .column:first-child {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .user-name {
      font-size: 1.4rem;
    }

    .bio {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 767px) {
    .profile-columns {
      width: 100%;
      max-width: 100%;
      margin: -1.4rem 0 2rem 0;
    }

    .profile-columns > .column:first-child {
      padding-top: 2rem;
      padding-bottom: 0;
    }

    .profile-columns > .column:nth-child(2) {
      padding-left: 0;
      padding-right: 0;
    }

    .review-row {
      margin-left: 0;
      margin-right: 0;
    }

    .vue-avatar--wrapper {
      margin: 0;
    }

    h4 {
      font-size: 1.7rem;
      font-weight: 700;
    }

    .reviewer-badge {
      padding: 0.3rem 0 0.3rem 0;
      width: 100%;
      max-width: 200px;
      margin: 0.4rem 0 3rem 0;
    }

    .reviewer-badge > .level > .level-item > p {
      line-height: 25px;
      height: 25px;
      font-size: 0.9rem;
    }

    .reviewer-badge > .level > .level-item:first-child > p {
      width: 22px;
      background-image: url(/static/img/others/rank@3x.png);
      background-size: 100% 100%;
      padding-left: 5px;
      font-size: 0.6rem;
    }

    .level.is-mobile .level-item:not(:last-child) {
      margin-bottom: 0;
      margin-right: 0;
      margin-left: 0.3rem;
    }

    .tabs {
      background-color: #ffffff;
    }

    .tabs > ul {
      border: none;
    }

    .tabs > ul > li > a {
      color: #58595B;
      font-size: 0.9rem;
      border-bottom: none;
      padding: 0.7rem 1rem;
    }

    .tabs > ul > li.is-active > a {
      color: #2EAAE1;
      border-bottom: 3px solid #2EAAE1;
    }

    .columns > .review-row:first-child > .card {
      /*border: none;*/
    }

    .bio {
      font-size: 0.9rem;
      margin: 0;
      padding: 2rem 1rem 0 1rem;
      width: 100%;
      max-width: 100%;
    }

    .mobile-profile {
      border-top: 1px solid #C9C9C9;
      margin-top: 0.7rem;
    }

    .totals-columns {
      margin: 2rem auto 1rem auto;
      max-width: 100%;
      width: 100%;
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .edit-options {
      max-width: 100%;
    }

    .icon.is-medium {
      margin-left: 1rem;
    }
  }

  *:focus {
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/UserProfile.vue